import { createRoot } from 'react-dom/client';
import { validateEnv } from '@constants/env';
import PageProviders from '@providers/PageProviders';
import App from './App';

validateEnv();

const container = document.getElementById('root');

if (!container) {
	throw new Error('Root element #root not found');
}

createRoot(container).render(
	<PageProviders>
		<App />
	</PageProviders>
);
